import { applyTheme } from '@wajeez-web/core/utils';
import { useEffect } from 'react';
import { Route } from 'react-router-dom';
import NavBar from '../NavBar/NavBar';
import SideBar from '../Sidebar/SideBar';
import AuthorizedLayout, { RouteLayoutProps } from './AuthorizedLayout';

const SuperAdminApp = ({ endpoints, routes }: RouteLayoutProps) => {
  useEffect(() => {
    applyTheme('super-admin');

    return () => {
      return;
    };
  }, []);

  // TODO: Update to be the same as the main app
  return (
    <AuthorizedLayout>
      {/* <Route
        path="*"
        element={
          <RestrictedRoute>
            <div className="h-screen flex overflow-hidden bg-white">
              <SideBar navigation={routes} />
              <div className="flex flex-col w-0 flex-1 overflow-hidden">
                <NavBar />
                <main className="flex-1 flex-grow overflow-y-auto focus:outline-none  h-full">
                  <div className=" h-full ">
                    <RestrictedRoutes routesItems={endpoints} />
                  </div>
                </main>
              </div>
            </div>
          </RestrictedRoute>
        }
      /> */}
    </AuthorizedLayout>
  );
};

export default SuperAdminApp;
